import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import Calendar from './pages/Calendar';
import CalendarShare from './pages/CalendarShare';
import CalendarSettings from './pages/CalendarSettings';
import ProfileSettings from './pages/ProfileSettings';
import Notifications from './pages/Notifications';
import Login from './pages/Login';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Examples from './pages/Examples';
import ResetPassword from './pages/ResetPassword';
import SetupCalendar from './pages/SetupCalendar';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <AuthProvider>
          <Toaster position="bottom-center" toastOptions={{ duration: 3000 }} />
          <Routes>
            <Route path="/calendar/:id" element={<Calendar />} />
            <Route
              path="*"
              element={
                <Layout>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/examples" element={<Examples />} />
                    <Route path="/calendar/:id/share" element={<CalendarShare />} />
                    <Route
                      path="/setup-calendar/:setupToken"
                      element={
                        <PrivateRoute>
                          <SetupCalendar />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/dashboard"
                      element={
                        <PrivateRoute>
                          <Dashboard />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/calendar/:id/settings"
                      element={
                        <PrivateRoute>
                          <CalendarSettings />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/profile/settings"
                      element={
                        <PrivateRoute>
                          <ProfileSettings />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/notifications"
                      element={
                        <PrivateRoute>
                          <Notifications />
                        </PrivateRoute>
                      }
                    />
                  </Routes>
                </Layout>
              }
            />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}